// @flow

const sharedInitialPayload = {
  page: 1,
  sortBy: "created_at",
  sortDirection: "desc",
  per_page: 30,
  offset: 0,
  count_by_status: true
};

export const bankAdvisorInitialPayload = {
  ...sharedInitialPayload,
  status: "new_for_bank"
};

export const bankAdvisorInitialPayloadV2 = {
  ...sharedInitialPayload,
  status: "new"
};

export const customerInitialPayload = {
  ...sharedInitialPayload,
  status: "new"
};
